import React, { Component } from "react";
import Header from "../components/IndexHeader/header";
import Helmet from "react-helmet";
import ProgressiveBackgroundImage from "../components/progressiveImage";
import Endorsements from "../components/Endorsements";
import Testimonials from "../components/Testimonials";

export default class IndexPage extends Component {
  render() {
    return (
      <div>
        <Helmet title={`Maid Service`} />
        {/* <Header /> */}
        <ProgressiveBackgroundImage
          preview={this.props.data.sizes.responsiveSizes.base64}
          src={this.props.data.sizes.responsiveSizes.originalImg}
          darken="0.33"
        >
          <Header />
        </ProgressiveBackgroundImage>
        <Endorsements list={this.props.data.endorsements} />
        <Testimonials
          bg={this.props.data.testimonials}
          quotes={this.props.data.quotes}
        />
      </div>
    );
  }
}

export const pageQuery = graphql`
  query pageQuery {
    sizes: imageSharp(id: { regex: "/headimg.jpg/" }) {
      responsiveSizes {
        base64
        originalImg
      }
    }
    testimonials: imageSharp(id: { regex: "/testimonials/" }) {
      responsiveSizes {
        base64
        originalImg
      }
    }
    endorsements: allImageSharp(filter: { id: { regex: "/endorsements/" } }) {
      edges {
        node {
          original {
            src
          }
        }
      }
    }
    quotes: allContentfulTestimonials {
      edges {
        node {
          user
          testimony {
            testimony
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js